import { z } from 'zod'

export const UserSkillSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  description: z.string(),
  summary: z.string(),
  created_at: z.string().datetime({ offset: true }),
  updated_at: z.string().datetime({ offset: true }),
})

export type UserSkill = z.infer<typeof UserSkillSchema>
export const PaxtonSkillSchema = UserSkillSchema.pick({ name: true, description: true, summary: true }).extend({ id: z.string() })
export type PaxtonSkill = z.infer<typeof PaxtonSkillSchema>
export type UserSkillWrite = { name: string; description: string }
